import React, { useEffect, useState } from "react";
import "../../css_files/Ticket/AssignedUsersTicket.css";
import axiosInstance from "../../api";
import CloseForm from "../Master/CloseForm";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function AssignedUsersTicket({
  ticketId,
  setShowAssignedUsers,
  showAssignedUsersEdit,
}) {
  const [users, setUsers] = useState([]);
  const [primaryTicketId, setPrimaryTicketId] = useState(0);
  const [userName, setUserName] = useState("");
  const [loading, setloading] = useState(false);
  const [ticketAccessData, setTicketAccessData] = useState([]);
  const [refresh, setrefresh] = useState(false);
  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Ticket/${ticketId}`)
      .then((res) => {
        setPrimaryTicketId(res.data.id);
      })
      .catch(console.log);
  }, [ticketId]);

  useEffect(() => {
    setloading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/TicketAccess/${ticketId}`)
      .then((res) => {
        setTicketAccessData(res.data);
        setloading(false);
      })
      .catch(console.log);
  }, [ticketId, refresh]);

  useEffect(() => {
    if (showAssignedUsersEdit)
      axiosInstance
        .get(`${process.env.REACT_APP_API_URL}/api/User/GetAllUsersDropdown`)
        .then((res) => {
          setUsers(res.data);
        })
        .catch(console.log);
  }, [showAssignedUsersEdit]);
  return (
    <section className="assigned-users-ticket-table">
      <section className="table" style={{ width: "70%" }}>
        <h1>Assigned Users For Ticket Id {ticketId}</h1>
        {showAssignedUsersEdit && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              axiosInstance
                .post(`${process.env.REACT_APP_API_URL}/api/TicketAccess`, {
                  Username: userName,
                  TicketId: ticketId,
                  PrimaryTicketId: primaryTicketId,
                })
                .then((res) => {
                  toast.success(res.data, {
                    position: "bottom-center",
                    theme: "dark",
                  });
                  setrefresh(!refresh);
                  setUserName("");
                })
                .catch((err) => {
                  if (err.response.status === 400)
                    toast.error(err.response.data, {
                      position: "bottom-center",
                      theme: "dark",
                    });
                });
            }}
          >
            <select
              required
              onChange={(e) => {
                setUserName(e.target.value);
              }}
            >
              <option value="">Select Users</option>
              {users.map((user) => (
                <option value={user.userID} selected={user.userID === userName}>
                  {user.userID} ({user.email})
                </option>
              ))}
            </select>
            <button type="submit">Submit</button>
          </form>
        )}
        <section>
          <div>
            <aside
              style={{
                gridTemplateColumns: `repeat(${
                  showAssignedUsersEdit ? "4" : "3"
                }, 1fr)`,
              }}
            >
              <blockquote>Username</blockquote>
              <blockquote>Email</blockquote>
              <blockquote>Role</blockquote>
              {showAssignedUsersEdit && <blockquote></blockquote>}
            </aside>
          </div>
          <div>
            {loading ? (
              <aside
                style={{
                  gridTemplateColumns: `repeat(${
                    showAssignedUsersEdit ? "4" : "3"
                  }, 1fr)`,
                }}
              >
                <blockquote
                  style={{
                    gridColumn: `span ${showAssignedUsersEdit ? "4" : "3"}`,
                  }}
                >
                  <center>
                    <i
                      className="fa-solid fa-spinner fa-spin "
                      style={{ fontSize: "2.5rem" }}
                    ></i>
                  </center>
                </blockquote>
              </aside>
            ) : ticketAccessData.length > 0 ? (
              ticketAccessData.map((x) => (
                <aside
                  style={{
                    gridTemplateColumns: `repeat(${
                      showAssignedUsersEdit ? "4" : "3"
                    }, 1fr)`,
                  }}
                >
                  <blockquote>{x.user.userID}</blockquote>
                  <blockquote>{x.user.email}</blockquote>
                  <blockquote>{x.user.role}</blockquote>
                  {showAssignedUsersEdit && (
                    <blockquote
                      onClick={() => {
                        Swal.fire({
                          icon: "error",
                          title: "Are You Sure?",
                          text: "This User Access Will Get Removed From This Ticket",
                          showConfirmButton: true,
                          showCancelButton: true,
                        }).then((result) => {
                          if (result.isConfirmed)
                            axiosInstance
                              .delete(
                                `${process.env.REACT_APP_API_URL}/api/TicketAccess/RemoveAccessByUsername?username=${x.user.userID}&ticketId=${ticketId}`
                              )
                              .then((res) => {
                                toast.success(res.data, {
                                  position: "bottom-center",
                                  theme: "dark",
                                });
                                setrefresh(!refresh);
                              })
                              .catch(console.log);
                        });
                      }}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </blockquote>
                  )}
                </aside>
              ))
            ) : (
              <blockquote
                style={{
                  gridColumn: `span ${showAssignedUsersEdit ? "4" : "3"}`,
                }}
              >
                <center>No Records Found</center>
              </blockquote>
            )}
          </div>
        </section>
        <CloseForm close={setShowAssignedUsers} />
      </section>
    </section>
  );
}

export default AssignedUsersTicket;
